import React, {useState, useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";
import Header  from "../../component/Header/Header";
import { ItemTransaction } from "../../component/ItemTransaction/ItemTransaction";
import classes from './PersonalAccount.module.scss'
import { useTranslation } from "react-i18next";

export const PersonalAccount = () => {

    const [isToken, setToken] = useState(true)
    const [tokenList, setTokenList] = useState('')
    const navigate = useNavigate()
    const {t} = useTranslation()
    const handleTab = () => {
        setToken(prev => !prev)
    }

    // useEffect(() => {
    //     if(!localStorage.getItem('token')){
    //         navigate('/signUp')
    //     }
    // },[])

    return(
        // <Link to="/signupMobile" className={classes.link}>Go to personal Account - signUp mobile Phone</Link>
        <div className={classes.account}>
            <div className="g-container">
                <div className={classes.account__wrapper}>
                    <Header />
                    <div className={classes.account__wrapper__tabs}>
                        <div className={classes.account__wrapper__tabs__element} onClick={!isToken ? handleTab : () => {}}>
                            <p className={isToken ? `${classes.account__wrapper__tabs__element_text} ${classes.account__wrapper__tabs__element_text_active}` : classes.account__wrapper__tabs__element_text }>{t('personal.tab1')}</p>
                            <div className={isToken ? `${classes.account__wrapper__tabs__element_devider} ${classes.account__wrapper__tabs__element_devider_active}` : classes.account__wrapper__tabs__element_devider}/>
                        </div>
                        <div className={classes.account__wrapper__tabs__element}  onClick={isToken ? handleTab : () => {}}>
                            <p className={!isToken ? `${classes.account__wrapper__tabs__element_text} ${classes.account__wrapper__tabs__element_text_active}` : classes.account__wrapper__tabs__element_text }>{t('personal.tab2')}</p>
                            <div className={!isToken ? `${classes.account__wrapper__tabs__element_devider} ${classes.account__wrapper__tabs__element_devider_active}` : classes.account__wrapper__tabs__element_devider}/>
                        </div>
                    </div>
                    <div className={classes.account__wrapper__info}>
                        {isToken ?
                        <div className={classes.account__wrapper__info__token}>
                            <div className={classes.account__wrapper__info__token__coin}>
                                <p className={classes.account__wrapper__info__token__coin_text}>{t('personal.summary')}</p>
                                <div className={classes.account__wrapper__info__token__coin__amount}> 
                                    <div className={classes.account__wrapper__info__token__coin__amount__cpay}>
                                        <div className={classes.account__wrapper__info__token__coin__amount__cpay__value}>
                                            <p className={classes.account__wrapper__info__token__coin__amount__cpay__value_descr}>{t('personal.amount')}</p>
                                            <p className={classes.account__wrapper__info__token__coin__amount__cpay__value_title}>4 tkn</p>
                                        </div>
                                        <img className={classes.account__wrapper__info__token__coin__amount__cpay_img} alt='token' src={require('../../img/cpayCoin.png')}/>
                                    </div>  
                                    <div className={classes.account__wrapper__info__token__coin__amount__balance}>
                                        <p className={classes.account__wrapper__info__token__coin__amount__balance_title}>{t('personal.dollars')}</p>
                                        <div className={classes.account__wrapper__info__token__coin__amount__balance__show}>
                                            <p className={classes.account__wrapper__info__token__coin__amount__balance__show_bright}>$50</p>
                                            <p className={classes.account__wrapper__info__token__coin__amount__balance__show_faded}>/ 1 tkn</p>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div className={classes.account__wrapper__info__token__transaction}>
                                <p className={classes.account__wrapper__info__token__transaction_title}>{t('personal.transactions')}</p>
                                {tokenList 
                                ? 
                                    <p className={classes.account__wrapper__info__token__transaction_empty}>{t('personal.emptyTransactions')}</p>
                                :
                                    <div className={classes.account__wrapper__info__token__transaction__list}>
                                        <ItemTransaction />
                                        <ItemTransaction />
                                    </div>
                                }
                            </div>
                        </div>
                        :
                        <div className={classes.account__wrapper__info__profile}>
                            <div className={classes.account__wrapper__info__profile__wrapper}>
                                <img className={classes.account__wrapper__info__profile__wrapper_img} src={require('../../img/addPhoto.png')} alt='avatar'/>
                                <p className={classes.account__wrapper__info__profile__wrapper_name}>Alex Zherko</p>
                                <p className={classes.account__wrapper__info__profile__wrapper_location}>Warsaw, Poland</p>
                                <p className={classes.account__wrapper__info__profile__wrapper_phone}>+(48) 797-494-943</p>
                            </div> 
                        </div>
                        }
                    </div>
                    <div className={classes.account__wrapper_blur1}/>
                    <div className={classes.account__wrapper_blur2}/>
                </div>
            </div>
        </div>
    )
}